// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3wzAd","colCheckbox":"styles_colCheckbox__2Tzt2"};